import React, { Component } from 'react';
import './DocumentMask.css';

class DocumentMask extends Component {
    constructor(props) {
        super(props);
        // console.log(this.state)
        this.state = { scanLinePosition: 0, scanLineSpeed: 5000 };

    }

    getMaskDimensions = (videoWidth, videoHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO) => {
        let verticalMargin = 20;
        let horizontalMargin = 50;

        if (DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO < 1 && videoHeight / videoWidth < 1) {
            //document is hotizontal and video is horizontal
            verticalMargin = 50;

        }

        const bestFitForDocumentMask = this.getBestFitForDocumentMask(
            videoWidth, videoHeight - 90, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO, horizontalMargin, verticalMargin)
        const maskWidth = bestFitForDocumentMask.maskWidth
        const maskHeight = bestFitForDocumentMask.maskHeight
        // console.log(`w: ${maskWidth} h: ${maskHeight}`)
        return { maskWidth, maskHeight };

    }

    getBestFitForDocumentMask = (availableWidth, availableHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO, horizontalMargin, verticalMargin) => {


        let maskWidth = 0
        let maskHeight = 0

        const dimensionsToFitByHeight = this.getDimensionsToFitByHeight(availableWidth, availableHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO, verticalMargin)
        const dimensionsToFitByWidth = this.getDimensionsToFitByWidth(availableWidth, availableHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO, horizontalMargin)

        const isFittingByWidthPossible = (dimensionsToFitByWidth.maskHeight <= availableHeight - 2 * verticalMargin)
        const isFittingByHeightPossible = (dimensionsToFitByHeight.maskWidth <= availableWidth - 2 * horizontalMargin)

        if (isFittingByWidthPossible && isFittingByHeightPossible) {
            if (dimensionsToFitByHeight.maskHeight > dimensionsToFitByWidth.maskHeight) {
                maskWidth = dimensionsToFitByHeight.maskWidth
                maskHeight = dimensionsToFitByHeight.maskHeight
            }
            else {
                maskWidth = dimensionsToFitByWidth.maskWidth
                maskHeight = dimensionsToFitByWidth.maskHeight
            }
        }
        else if (isFittingByWidthPossible && !isFittingByHeightPossible) {
            maskWidth = dimensionsToFitByWidth.maskWidth
            maskHeight = dimensionsToFitByWidth.maskHeight

        }
        else if (!isFittingByWidthPossible && isFittingByHeightPossible) {
            maskWidth = dimensionsToFitByHeight.maskWidth
            maskHeight = dimensionsToFitByHeight.maskHeight

        }
        else {
            console.log("go home, you're drunk")
        }
        return ({ maskWidth, maskHeight })
    }
    getDimensionsToFitByWidth = (availableWidth, availableHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO, margin) => {
        let maskWidth = availableWidth - 2 * margin
        let maskHeight = maskWidth * DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO;
        return ({ maskWidth, maskHeight })
    }

    getDimensionsToFitByHeight = (availableWidth, availableHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO, margin) => {
        let maskHeight = availableHeight - 2 * margin
        let maskWidth = maskHeight / DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO;
        return ({ maskWidth, maskHeight })
    }

    componentDidMount() {
        setTimeout(() => this.setState({ scanLinePosition: 100 }), 100);
        var intervalId = setInterval(() => {
            if (this.state.scanLinePosition === 100)
                this.setState({ scanLinePosition: 0 });
            else
                this.setState({ scanLinePosition: 100 });
        }, this.state.scanLineSpeed);

        this.setState({ intervalId: intervalId });
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    render() {
        const { videoWidth, videoHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO } = this.props;
        console.log(videoHeight, videoWidth)
        const maskDimensions = this.getMaskDimensions(videoWidth, videoHeight, DOCUMENT_MASK_HEIGHT_TO_WIDTH_RATIO)

        return (
            <div ref={(divElement) => { this.divElement = divElement }} className="DocumentMaskWrapper">
                <div className="DocumentMask" style={{
                    borderColor: this.props.DOCUMENT_MASK_ACCEPTED ? "#34a853" : "#ea4335",
                    height: `${maskDimensions.maskHeight}px`,
                    width: `${maskDimensions.maskWidth}px`
                }}>
                    {!this.props.DOCUMENT_MASK_ACCEPTED &&
                        <div
                            className="DocumentMaskScanLine"
                            style={{
                                width: `${this.state.scanLinePosition}%`,
                                transition: `${this.state.scanLineSpeed}ms linear width 0ms`
                            }} 
                        />
                    }
                </div>
            </div>
        );
    }
}

export default DocumentMask;